import React from 'react';
import PropTypes from 'prop-types';
import useCountUp from '../../../hooks/useCountUp';

/**
 * The oversized single-figure card from the reference — label at the top,
 * the number filling the rest of the card and counting up on load.
 */
const BigPercentCard = ({ label, percent, caption }) => {
  const safePercent = Number.isFinite(percent) ? Math.max(0, Math.min(100, percent)) : null;
  const animated = useCountUp(safePercent ?? 0);

  return (
    <div className="bg-white dark:bg-shoorah-darkBgTabColor border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder rounded-2xl p-4 md:p-5 flex flex-col justify-between h-full min-h-[180px]">
      <h4 className="text-base font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg leading-snug">
        {label}
      </h4>

      <div>
        <span className="block text-5xl md:text-6xl font-semibold text-shoorah-lightBlack dark:text-shoorah-darkBg tabular-nums leading-none">
          {safePercent === null ? '—' : `${Math.round(animated)}%`}
        </span>
        {caption ? <p className="text-xs text-shoorah-gray3 mt-2">{caption}</p> : null}
      </div>
    </div>
  );
};

BigPercentCard.propTypes = {
  label: PropTypes.string.isRequired,
  percent: PropTypes.number,
  caption: PropTypes.string
};

export default BigPercentCard;
